module.exports = __webpack_public_path__ + "img/5.17bd5730.jpg";